import React, { useMemo } from 'react'
import { useMobile } from '../../hooks'
import { ColumnTable } from './types/TableTypes'

type TableHeadProps = {
  columns: ColumnTable[]
  subHeader?: JSX.Element
}

export const TableHead = ({ columns, subHeader }: TableHeadProps) => {
  const isMobile = useMobile()
  const nCols = useMemo(() => {
    if (!isMobile) {
      return columns.length
    } else {
      return columns.filter((col) => !col.hideOnMobile).length
    }
  }, [])

  return (
    <thead>
      <tr>
        {columns.map((col, i) => {
          if (isMobile && col.hideOnMobile) return
          return (
            <th
              className={col.thClassName || ''}
              key={`header_${i}`}
              style={{
                minWidth: col.width ? col.width : '',
                width: col.width ? col.width : ''
              }}
            >
              {col.headerText}
            </th>
          )
        })}
      </tr>
      {nCols > 0 && subHeader && (
        <tr className='sub-header'>
          <th colSpan={nCols}>{subHeader} </th>
        </tr>
      )}
    </thead>
  )
}
